import { WaysResult } from "slotworks/model/gameplay/records/results/ways-result";

export class PartnerConnectWaysResult extends WaysResult {
    public step: number;
}
